import '../commons/styles/footer.scss'
import './styles/newsIndex.scss'
import CommonHeader from '../commons/components/CommonHeader'
import CommonFooter from '../commons/components/CommonFooter'
import QrCodes from '../commons/components/QrCodes.vue'
import 'swiper/dist/css/swiper.min.css'
import Swiper from "swiper"

Vue.config.productionTip = false
new Vue({
  render: h => h(CommonHeader, {
    props: {
      active: 'newsindex'
    }
  }),
}).$mount('#header')

new Vue({
  render: h => h(CommonFooter)
}).$mount('#footerCommon')

new Vue({
  render: h => h(QrCodes)
}).$mount('#qrCodes')

new Swiper(".swiper-container", {
  loop: true,
  pagination: ".swiper-pagination",
  nextButton: ".swiper-button-next",
  prevButton: ".swiper-button-prev",
  autoplay: 8000,
  // disableOnInteraction: true,
});